import { LoadingService } from '@serpro/ngx-suite-rfb';
import { LudService } from './../../../shared/services/lud.service';
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Orgao } from "src/app/shared/model/orgao.model";
import { Recurso } from "src/app/shared/model/recurso.model";
import { TipoAto } from "src/app/shared/model/tipo-ato.model";
import { AtoLudConsulta } from 'src/app/shared/model/ato-lud-consulta.model';
import { AtoRecurso } from 'src/app/shared/model/ato-recurso.model';
import { BancoRecursos } from 'src/app/shared/util/banco-recursos.util';

@Component({
    selector: 'app-painel2-pesquisa',
    templateUrl: './painel2-pesquisa.component.html',
    styleUrls: ['./painel2-pesquisa.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class Painel2PesquisaComponent {
    @Input() filtroPesquisa: FiltroPesquisa;
    @Input() bancoRecursos: BancoRecursos;
    @Input() cacheDominios: CacheDominios = new CacheDominios();
    @Output() aoPesquisar = new EventEmitter<Recurso[]>();

    recursos: Recurso[] = [];
    recurso: Recurso | undefined;
    exibirMensagemAlerta = false;
    mensagemAlerta = "";

    constructor(
        private readonly ludService: LudService,
        private readonly loadingService: LoadingService,
    ) {}

    public limparFiltroPesquisa() {
        this.filtroPesquisa.tipoAto = null;
        this.filtroPesquisa.orgao = null;
        this.filtroPesquisa.numeroAto = '';
        this.filtroPesquisa.dataAto = null;
        this.filtroPesquisa.anoAto = '';
        this.filtroPesquisa.idAto = '';
        this.filtroPesquisa.identificador = '';
    }

    public pesquisar() {
        this.recursos = [];
        if (this.filtroPesquisa.tipoPesquisa === 1) {            
            const atoLudConsulta = AtoLudConsulta.fromFiltroPesquisa(this.filtroPesquisa);
            this.loadingService.show();
            this.ludService.consultarAtos(atoLudConsulta).subscribe({
                next: (recursos: AtoRecurso[]) => {
                    this.recursos = recursos.map((atoRecurso: AtoRecurso) => {
                        if (atoRecurso.recurso) {
                            this.bancoRecursos.ordenarFragmentosPorDispositivo(atoRecurso.recurso);
                            this.bancoRecursos.incluirAtoRecursoNormas(atoRecurso);
                            return atoRecurso.recurso;
                        }
                        const recurso = new Recurso();
                        recurso.identificador = atoRecurso.epigrafe;
                        recurso.incluirSinonimo(atoRecurso.epigrafe);
                        recurso.incluirFragmentoIntegra();
                        recurso.idAto = atoRecurso.idAto;
                        atoRecurso.recurso = recurso;
                        this.bancoRecursos.incluirAtoRecursoNormas(atoRecurso);
                        return recurso;
                    });
                    this.ordenarRecursos();
                    this.loadingService.hide();
                    this.aoPesquisar.emit(this.recursos);
                },
                error: () => {
                    this.loadingService.hide();
                    this.aoPesquisar.emit([]);
                } 
            });
        } else if (this.filtroPesquisa.tipoPesquisa === 2) {
            const texto = this.filtroPesquisa.identificador;
            if (texto && texto.trim().length > 0) {
                this.consultarLudsInternet(texto.trim());
            } else {
                this.exibirMensagemAlerta = true;
                this.mensagemAlerta = "Nome do LUD ou sinônimo não informado";
            }
        } else {
            this.aoPesquisar.emit([]);
        }
    }

    private consultarLudsInternet(texto: string) {
        this.loadingService.show();
        this.ludService.consultarLudsInternet(texto).subscribe({
            next: (recursos: Recurso[]) => {
                this.recursos = recursos;
                for (const r of recursos) {
                    this.bancoRecursos.ordenarFragmentosPorDispositivo(r);
                    this.bancoRecursos.incluirRecursoInternet(r);
                }
                this.loadingService.hide();
                this.exibirMensagemAlerta = false;
                this.aoPesquisar.emit(recursos);
            },
            error: (e) => {
                this.loadingService.hide();
                this.exibirMensagemAlerta = true;
                this.mensagemAlerta = e.error.message;
                this.aoPesquisar.emit([]);
            } 
        });
    }

    public compareTiposAto = (p1: TipoAto, p2: TipoAto): boolean => {
        return p1 && p2 ? p1.idTipoAto === p2.idTipoAto : p1 === p2;
    }

    public compareOrgaos = (p1: Orgao, p2: Orgao): boolean => {
        return p1 && p2 ? p1.idOrgao === p2.idOrgao : p1 === p2;
    }

    private ordenarRecursos() {
        this.recursos.sort((a, b) => {
            if (!a.idRecurso) {
                return 1;
            }
            if (!b.idRecurso) {
                return -1;
            }
            return 0;
        });
    }
}

export class FiltroPesquisa {
    tipoPesquisa = -1;
    idAto: string;
    tipoAto: TipoAto | null;
    orgao: Orgao | null;
    numeroAto: string;
    dataAto: Date | null;
    anoAto: string;
    identificador: string;

    limpar() {
        this.idAto = '';
        this.tipoAto = null;
        this.orgao = null;
        this.numeroAto = '';
        this.dataAto = null;
        this.anoAto = '';
        this.identificador = '';
    }
}

export class CacheDominios {
    tiposAto: TipoAto[] = [];
    labelsTipoAto: string[] = [];
    orgaos: Orgao[] = [];
    labelsOrgao: string[] = [];
}